var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero is-fullheight",staticStyle:{"position":"relative"},attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fadeLeft","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }